// once we work on the functionality, the actions will be created here
// sample code

const REGISTER_STARTED = 'REGISTER_STARTED';
const REGISTER_COMPLETED = 'REGISTER_COMPLETED';
const REGISTER_SUCCESS = 'REGISTER_SUCCESS';

const register = (request) => {
	return {
		type: REGISTER_STARTED,
		request,
	};
};

const registerCompleted = () => {
	return {
		type: REGISTER_COMPLETED,
	};
};

const registerSuccess = (details) => {
	return {
		type: REGISTER_SUCCESS,
		details,
	};
};

export default {
	types: {
		REGISTER_STARTED,
		REGISTER_COMPLETED,
		REGISTER_SUCCESS,
	},
	creators: {
		register,
		registerCompleted,
		registerSuccess,
	},
};
